"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nCore = void 0;
const i18next_1 = require("i18next");
const languagesObj_1 = require("./I18nCore/languagesObj");
const makeDates_1 = require("./I18nCore/makeDates");
const makeDefaultInitOptions_1 = require("./I18nCore/makeDefaultInitOptions");
const makeFormatNumber_1 = require("./I18nCore/makeFormatNumber");
const makeLoadResourcesPlugin_1 = require("./I18nCore/makeLoadResourcesPlugin");
const makeMeasurements_1 = require("./I18nCore/makeMeasurements");
const makePhrasesPlaceholderFunc_1 = require("./I18nCore/makePhrasesPlaceholderFunc");
const makeTFunc_1 = require("./I18nCore/makeTFunc");
class I18nCore {
    constructor(o) {
        this._NS_templates = 'templates';
        this._NS_unitSymbols = 'unitSymbols';
        this._makeCustomTranslation = o.makeCustomTranslation;
        this._momentLibrary = o.momentLibrary;
        this._i18nInstance = (0, i18next_1.createInstance)();
        this._translateLngCache = new Map();
        this._momentFormatsByLanguage = new Map();
        this._namespacesOptions = o.namespaces;
        this._namespaces = Array.from(new Set([this._NS_templates, this._NS_unitSymbols, ...o.namespaces]));
        this._initOptions = o.makeInitOptions
            ? o.makeInitOptions((0, makeDefaultInitOptions_1.makeDefaultInitOptions)(this._namespaces))
            : (0, makeDefaultInitOptions_1.makeDefaultInitOptions)(this._namespaces);
        this._i18nInstance.use((0, makeLoadResourcesPlugin_1.makeLoadResourcesPlugin)({
            defaultNamespace: this._namespaces[0],
            fetchMomentResources: o.fetchMomentResources,
            fetchPhraseResources: o.fetchPhraseResources,
            momentFormatsByLanguage: this._momentFormatsByLanguage,
            momentLibrary: this._momentLibrary,
            onFetchResourceError: o.onFetchResourceError,
        }));
        const tTemplatesGlobalLng = (0, makeTFunc_1.makeTFunc)(this._i18nInstance, this._NS_templates);
        const tUnitSymbolsGlobalLng = (0, makeTFunc_1.makeTFunc)(this._i18nInstance, this._NS_unitSymbols);
        const formatNumberGlobalLng = (0, makeFormatNumber_1.makeFormatNumber)(tTemplatesGlobalLng);
        this.globalLng = {
            translate: {
                phrases: o.namespaces.reduce((acc, namespace) => {
                    return {
                        ...acc,
                        [namespace]: (0, makeTFunc_1.makeTFunc)(this._i18nInstance, namespace),
                    };
                }, {
                    placeholder: (0, makePhrasesPlaceholderFunc_1.makePhrasesPlaceholderFunc)(this._i18nInstance),
                }),
                dates: (0, makeDates_1.makeDates)(this._momentFormatsByLanguage, this._momentLibrary, this._i18nInstance),
                measurements: (0, makeMeasurements_1.makeMeasurements)(formatNumberGlobalLng, tTemplatesGlobalLng, tUnitSymbolsGlobalLng),
                formatNumber: formatNumberGlobalLng,
                ...this._makeCustomTranslation({
                    namespaces: o.namespaces,
                    lng: undefined,
                    i18nInstance: this._i18nInstance,
                }),
            },
            changeLanguage: async (lng) => {
                await this._i18nInstance.changeLanguage(lng);
                await o.onGlobalLanguageChange?.(lng);
            },
        };
    }
    async init() {
        await this._i18nInstance.init(this._initOptions);
    }
    findClosestLanguage(languagesOrderedByPreference) {
        for (const preferredLanguage of languagesOrderedByPreference) {
            const preferredLanguageCleaned = preferredLanguage.trim().toLowerCase();
            const foundLanguage = I18nCore.LANGUAGES.find((x) => x.toLowerCase() === preferredLanguageCleaned);
            if (foundLanguage) {
                return foundLanguage;
            }
        }
        return 'en';
    }
    async loadAllLanguages() {
        await this._i18nInstance.loadLanguages(I18nCore.LANGUAGES);
    }
    // TODO: i18n - This is a quick fix for reports-weekly-general-lambda to use all languages from classic. We'll soon refactor I18nCore to allow passing in enabled languages
    async loadAllLanguagesClassic() {
        await this._i18nInstance.loadLanguages(['ca', 'en', 'en-AU', 'es', 'es-ES', 'fr', 'it']);
    }
    getDataByLanguage(lng) {
        return this._i18nInstance.getDataByLanguage(lng);
    }
    translate(lng) {
        let cachedLng = this._translateLngCache.get(lng);
        if (!cachedLng) {
            const tTemplatesFixedLng = (0, makeTFunc_1.makeTFunc)(this._i18nInstance, this._NS_templates, lng);
            const tUnitSymbolsFixedLng = (0, makeTFunc_1.makeTFunc)(this._i18nInstance, this._NS_unitSymbols, lng);
            const formatNumberFixedLng = (0, makeFormatNumber_1.makeFormatNumber)(tTemplatesFixedLng);
            cachedLng = {
                phrases: this._namespacesOptions.reduce((acc, namespace) => {
                    return {
                        ...acc,
                        [namespace]: (0, makeTFunc_1.makeTFunc)(this._i18nInstance, namespace, lng),
                    };
                }, {
                    placeholder: (0, makePhrasesPlaceholderFunc_1.makePhrasesPlaceholderFunc)(this._i18nInstance, lng),
                }),
                dates: (0, makeDates_1.makeDates)(this._momentFormatsByLanguage, this._momentLibrary, this._i18nInstance, lng),
                measurements: (0, makeMeasurements_1.makeMeasurements)(formatNumberFixedLng, tTemplatesFixedLng, tUnitSymbolsFixedLng),
                formatNumber: formatNumberFixedLng,
                ...this._makeCustomTranslation({
                    namespaces: this._namespacesOptions,
                    lng: lng,
                    i18nInstance: this._i18nInstance,
                }),
            };
            this._translateLngCache.set(lng, cachedLng);
        }
        return cachedLng;
    }
}
exports.I18nCore = I18nCore;
I18nCore.LANGUAGES = Object.keys(languagesObj_1.languagesObj).sort();
//# sourceMappingURL=I18nCore.js.map